import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Apollo } from 'apollo-angular';
import { Presentation } from 'app/graphql';
import { presentationQuery } from './presentation.query';

@Component({
  selector: 'app-root', // tslint:disable-line:component-selector
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isBusy = false;
  presentation: Presentation;

  constructor(
    private apollo: Apollo,
    private location: Location,
  ) {}

  async ngOnInit(): Promise<void> {
    const match = /^\/?([0-9A-Za-z]+)/.exec(this.location.path());
    if (match && match[1]) {
      const presentationId = match[1];

      this.isBusy = true;
      try {
        const { presentation } = await presentationQuery({ presentationId })(
          this.apollo,
        );

        if (!!presentation.layoutId) {
          window.location.href = `https://classic.slidebean.com/${presentationId}`;
          return;
        }

        this.presentation = presentation;
        this.isBusy = false;
      } catch (error) {
        console.warn('Could not load presentation', error);
        this.isBusy = false;
      }
    }
  }
}
